import { createRouter, createWebHistory } from 'vue-router'
//import RengongView from '../views/rengongcuiping/RengongYlqRwKF2025View.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/rengongcuiping/RengongCPKPIView.vue')
  },
  {
    path: '/RengongCPKPI',
    name: 'RengongCPKPI',
    component: () => import('../views/rengongcuiping/RengongCPKPIView.vue')
  },
  {
    path: '/RengongKFKPI',
    name: 'RengongKFKPI',
    component: () => import('../views/rengongcuiping/RengongKFKPIView.vue')
  },
  {
    path: '/RengongGRKPI',
    name: 'RengongGRKPI',
    component: () => import('../views/rengongcuiping/RengongGrKPIView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
